/* ====================================================================
   FLOOREVER — PAGE COLLECTION (sections/floorever-collection.liquid)
   Vanilla JS, defer, aucune dépendance.

   Améliorations progressives uniquement — tout fonctionne sans JS :
   - tri : le <select> (rattaché au form GET des filtres par form=) se
     soumet au changement ; bouton « OK » de secours masqué (.is-js) ;
   - panneau de filtres S&D : fermeture croix / Échap / clic dehors
     (le <details> natif reste le mécanisme d'ouverture) ;
   - FILTRES RAPIDES [data-qf] : barre de pilules 100 % client
     (famille de couleur, type de pose, couche d'usure, format),
     masquée sans JS par le CSS.

   Classe is-js : posée sur <html> dès le <head> par layout/theme.liquid,
   pour que les styles « avec JS » s'appliquent au premier affichage ;
   posée trop tard, elle faisait remonter la grille, CLS 0,088, ticket 47
   de la recette. Elle est encore posée ici sur la racine de la section.

   FILTRES RAPIDES — contrat :
   - pilules [data-qf-pill] (data-valeur, '' = tous) groupées par
     [data-qf-groupe="famille|gamme|pose|souscouche|usure|format|embossage"] ; sélection UNIQUE
     par groupe (aria-pressed), ET logique entre groupes ;
   - cible = chaque <li> de .coll-grid ; l'article porte les jetons :
     data-famille (valeur exacte), data-pose / data-usure /
     data-formats (jetons séparés par espaces — cartes groupées =
     union du groupe de décor), data-format (repli historique) ;
   - compteur [data-qf-resultat] (gabarit data-libelle, [n]/[total])
     en aria-live, avec bouton « Tout afficher » injecté ;
   - état vide [data-qf-vide] + bouton [data-qf-reset] ;
   - persistance dans le HASH (#qf=groupe:valeur;…) — SEO-neutre,
     survit au rechargement/partage ; les facettes S&D (bascule)
     utilisent, elles, de vrais paramètres d'URL serveur.

   Init idempotente (data-coll-init) + shopify:section:load — corrige
   le point d'audit « listeners document orphelins ».
   ==================================================================== */
(function () {
  'use strict';

  /* Dérive pose/usure/embossage d'un NOM de gamme — mêmes règles que
     card-produit.liquid (Rigid/Stone avant Clic ; règle embossage
     Christopher 10/07/2026 : Rigid/Stone = aléatoire, sinon synchro). */
  function deriveGamme(gamme) {
    var pose = /Glue/.test(gamme) ? 'coller'
      : (/Rigid|Plus|Stone/.test(gamme) ? 'rigide'
        : (/Clic/.test(gamme) ? 'souple' : ''));
    /* Résistance : 3 classes — Plus et 55 Glue Pro = 34 (très intensif, 0,55 ;
       55 Glue Pro : décision du 16/10/2026),
       autres 55 = 33 (intensif, 0,55), 30 = 31 (normal, 0,30).
       Plus AVANT 55 (« 55 Clic Plus » contient les deux). */
    var usure = /Plus|Glue Pro/.test(gamme) ? '34'
      : (/55/.test(gamme) ? '33' : (/30/.test(gamme) ? '31' : ''));
    var embossage = /Rigid|Stone/.test(gamme) ? 'aleatoire' : 'synchro';
    /* Sous-couche intégrée (17/10/2026) : Rigid et Plus, sinon sans ; aucune
       valeur hors gammes clic ou à coller, ni pour 55 Clic Stone (comme le Liquid). */
    var souscouche = (!/Clic|Glue/.test(gamme) || /Stone/.test(gamme)) ? ''
      : (/Rigid|Plus/.test(gamme) ? 'integree' : 'sans');
    return { pose: pose, usure: usure, embossage: embossage, souscouche: souscouche };
  }

  /* ---------------- Filtres rapides ---------------- */
  function initFiltresRapides(racine, hooks) {
    var bar = racine.querySelector('[data-qf]');
    if (!bar) return;
    bar.hidden = false;

    var lis = Array.prototype.slice.call(racine.querySelectorAll('.coll-grid > li'));
    var resultat = racine.querySelector('[data-qf-resultat]');
    var vide = racine.querySelector('[data-qf-vide]');
    var grille = racine.querySelector('.coll-grid');
    var etat = {}; /* groupe -> valeur ('' = inactif) */

    function jetons(article, attr, separateur) {
      var v = article.getAttribute(attr);
      return v ? v.split(separateur || /\s+/).filter(Boolean) : [];
    }

    function correspond(article) {
      /* Carte groupée (17/10/2026, contre-vérification) : visible seulement
         si UNE de ses gammes remplit TOUS les critères actifs. Le test
         critère par critère sur l'union des jetons gardait une carte dont
         une gamme est rigide et une autre en 0,55 mm, sans gamme qui soit
         les deux. La famille est au niveau du décor. */
      var membres = article.querySelectorAll('[data-membre]');
      if (membres.length > 1) {
        if (etat.famille && article.getAttribute('data-famille') !== etat.famille) return false;
        for (var i = 0; i < membres.length; i++) {
          if (membreCorrespond(membres[i])) return true;
        }
        return false;
      }
      for (var g in etat) {
        var v = etat[g];
        if (!v) continue;
        if (g === 'famille') {
          if (article.getAttribute('data-famille') !== v) return false;
        } else if (g === 'gamme') {
          /* noms de gammes avec espaces -> jetons séparés par « | » */
          if (jetons(article, 'data-gammes', '|').indexOf(v) < 0) return false;
        } else if (g === 'embossage') {
          if (jetons(article, 'data-embossage').indexOf(v) < 0) return false;
        } else if (g === 'souscouche') {
          if (jetons(article, 'data-souscouche').indexOf(v) < 0) return false;
        } else if (g === 'pose') {
          if (jetons(article, 'data-pose').indexOf(v) < 0) return false;
        } else if (g === 'usure') {
          if (jetons(article, 'data-usure').indexOf(v) < 0) return false;
        } else if (g === 'format') {
          var fs = jetons(article, 'data-formats');
          if (!fs.length) {
            var f1 = article.getAttribute('data-format');
            if (f1) fs = [f1];
          }
          if (fs.indexOf(v) < 0) return false;
        }
      }
      return true;
    }

    function actif() {
      for (var g in etat) {
        if (etat[g]) return true;
      }
      return false;
    }

    /* Un MEMBRE (bloc prix d'une gamme du groupe) correspond-il aux
       filtres actifs ? famille = niveau décor, ne discrimine pas. */
    function membreCorrespond(membre) {
      var g = membre.getAttribute('data-gamme') || '';
      var d = deriveGamme(g);
      if (etat.gamme && g !== etat.gamme) return false;
      if (etat.pose && d.pose !== etat.pose) return false;
      if (etat.usure && d.usure !== etat.usure) return false;
      if (etat.embossage && d.embossage !== etat.embossage) return false;
      if (etat.souscouche && d.souscouche !== etat.souscouche) return false;
      if (etat.format && membre.getAttribute('data-format') !== etat.format) return false;
      return true;
    }

    /* Carte groupée : bascule le bloc prix vers le membre le moins cher
       au m² PARMI CEUX QUI CORRESPONDENT, ajuste le « dès » (masqué si
       une seule gamme correspond — prix exact), filtre les bulles de
       gammes, met à jour la note « Existe en N gammes » et data-prix-m2
       (le tri au m² suit le prix affiché). État sans filtre = min du
       groupe complet = rendu serveur (idempotent). */
    function ajusterGroupe(article) {
      var membres = Array.prototype.slice.call(article.querySelectorAll('[data-membre]'));
      if (membres.length < 2) return;

      var retenus = membres.filter(membreCorrespond);
      if (!retenus.length) retenus = membres; /* la carte est masquée par l'union de toute façon */

      var min = retenus.reduce(function (a, b) {
        return parseInt(b.getAttribute('data-prix-m2'), 10) < parseInt(a.getAttribute('data-prix-m2'), 10) ? b : a;
      });
      membres.forEach(function (m) { m.hidden = m !== min; });

      var prefixe = min.querySelector('[data-prefixe]');
      if (prefixe) prefixe.hidden = retenus.length < 2;

      article.setAttribute('data-prix-m2', min.getAttribute('data-prix-m2'));

      /* Le clic doit mener au produit AFFICHÉ : les liens de la carte
         (image + titre, [data-carte-lien]) suivent le membre visible.
         Le bouton échantillon, lui, reste sur le décor (même échantillon
         pour toutes les gammes — règle produit). */
      var url = min.getAttribute('data-url');
      if (url) {
        article.querySelectorAll('[data-carte-lien]').forEach(function (a) {
          a.setAttribute('href', url);
        });
      }

      /* L'étiquette de gamme au-dessus du titre suit AUSSI le membre
         affiché (sinon « 30 Clic Rigid » coifferait un prix 55 Clic Plus). */
      var etiquette = article.querySelector('[data-carte-gamme]');
      if (etiquette) {
        var nomGamme = etiquette.querySelector('[data-gamme-nom]') || etiquette;
        nomGamme.textContent = min.getAttribute('data-gamme');
        /* Étiquette = lien vers la collection de la gamme (17/10/2026),
           sans lien quand c'est la page affichée. */
        if (etiquette.tagName === 'A') {
          var urlGamme = min.getAttribute('data-url-gamme');
          if (urlGamme) etiquette.setAttribute('href', urlGamme);
          else etiquette.removeAttribute('href');
        }
      }

      var gammesOk = retenus.map(function (m) { return m.getAttribute('data-gamme'); });
      /* Une seule gamme retenue : plus de bulle, l'étiquette suffit. */
      article.querySelectorAll('[data-chip-gamme]').forEach(function (chip) {
        chip.hidden = retenus.length < 2 || gammesOk.indexOf(chip.getAttribute('data-chip-gamme')) < 0;
      });
      var note = article.querySelector('[data-note-gammes]');
      if (note) {
        if (retenus.length > 1) {
          note.textContent = (note.getAttribute('data-gabarit') || 'Existe en [n] gammes').replace('[n]', retenus.length);
          note.hidden = false;
        } else {
          note.hidden = true;
        }
      }
    }

    function majHash() {
      var parts = [];
      for (var g in etat) {
        if (etat[g]) parts.push(g + ':' + encodeURIComponent(etat[g]));
      }
      var url = window.location.pathname + window.location.search + (parts.length ? '#qf=' + parts.join(';') : '');
      window.history.replaceState(null, '', url);
    }

    function appliquer() {
      var visibles = 0;
      lis.forEach(function (li) {
        var article = li.querySelector('article');
        var ok = article ? correspond(article) : true;
        li.hidden = !ok;
        if (ok) {
          visibles += 1;
          if (article) ajusterGroupe(article);
        }
      });

      if (resultat) {
        if (actif()) {
          var gabarit = resultat.dataset.libelle || '[n] décors sur [total]';
          resultat.textContent = gabarit
            .replace('[n]', visibles)
            .replace('[total]', lis.length);
          var raz = document.createElement('button');
          raz.type = 'button';
          raz.setAttribute('data-qf-reset', '');
          raz.textContent = 'Tout afficher';
          resultat.appendChild(raz);
          resultat.hidden = false;
        } else {
          resultat.textContent = '';
          resultat.hidden = true;
        }
      }
      if (vide) vide.hidden = visibles > 0;
      if (grille) grille.hidden = visibles === 0;
      majHash();
      /* les prix affichés ont pu changer : re-trier si un tri m² est actif */
      if (hooks && hooks.resort) hooks.resort();
    }

    function reinitialiser() {
      etat = {};
      bar.querySelectorAll('[data-qf-pill]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.valeur === '' ? 'true' : 'false');
      });
      appliquer();
    }

    function choisir(groupe, valeur) {
      etat[groupe] = valeur;
      var conteneur = bar.querySelector('[data-qf-groupe="' + groupe + '"]');
      if (conteneur) {
        conteneur.querySelectorAll('[data-qf-pill]').forEach(function (b) {
          b.setAttribute('aria-pressed', b.dataset.valeur === valeur ? 'true' : 'false');
        });
      }
    }

    bar.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-qf-pill]');
      if (!pill) return;
      var groupe = pill.closest('[data-qf-groupe]');
      if (!groupe) return;
      choisir(groupe.dataset.qfGroupe, pill.dataset.valeur || '');
      appliquer();
    });

    /* boutons de réinitialisation : état vide (Liquid) + compteur (injecté) */
    racine.addEventListener('click', function (e) {
      if (e.target.closest('[data-qf-reset]')) reinitialiser();
    });

    /* Persistance : relire le hash au chargement (#qf=famille:X;pose:y). */
    var h = window.location.hash;
    if (h && h.indexOf('#qf=') === 0) {
      h.slice(4).split(';').forEach(function (part) {
        var i = part.indexOf(':');
        if (i < 1) return;
        var groupe = part.slice(0, i);
        var valeur = decodeURIComponent(part.slice(i + 1));
        var conteneur = bar.querySelector('[data-qf-groupe="' + groupe + '"]');
        if (!conteneur) return;
        var existe = Array.prototype.some.call(
          conteneur.querySelectorAll('[data-qf-pill]'),
          function (b) { return b.dataset.valeur === valeur; }
        );
        if (existe) choisir(groupe, valeur);
        /* pilule rangée dans le repli « Plus de filtres » (mobile) : on l'ouvre
           pour que le critère actif reste visible */
        var pli = conteneur.closest('details[data-pli]');
        if (existe && pli && !pli.open) pli.open = true;
      });
      appliquer();
    }
  }

  /* ---------------- Tri + panneau S&D (existant) ---------------- */
  function init(racine) {
    if (racine.dataset.collInit === 'true') return;
    racine.dataset.collInit = 'true';

    racine.classList.add('is-js');

    /* Fiche « en bref » : en mobile, les pastilles défilent à l'horizontale ;
       la liste prend alors le focus clavier et défile aux flèches (axe,
       scrollable-region-focusable, ticket 49 de la recette). Dès qu'elle ne
       défile plus, 768 px et plus, pas d'arrêt de tabulation inutile. */
    var fiche = racine.querySelector('[data-coll-fiche]');
    if (fiche) {
      var majFiche = function () {
        if (fiche.scrollWidth > fiche.clientWidth + 1) fiche.setAttribute('tabindex', '0');
        else fiche.removeAttribute('tabindex');
      };
      var ficheAttente = false;
      majFiche();
      window.addEventListener('resize', function () {
        if (ficheAttente) return;
        ficheAttente = true;
        window.requestAnimationFrame(function () {
          ficheAttente = false;
          majFiche();
        });
      }, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(majFiche);
    }

    var form = racine.querySelector('[data-coll-form]');
    var tri = racine.querySelector('[data-coll-sort]');
    var drawer = racine.querySelector('[data-coll-drawer]');

    /* Tri au m² CLIENT : les options data-m2 réordonnent la grille selon
       data-prix-m2 (le prix AFFICHÉ, €/m² — « dès » du groupe inclus) au
       lieu de soumettre sort_by=price-* qui trie au COLIS (faux en €/m²,
       colis de 1,62 à 2,70 m²). Sans JS : submit natif (approximatif).
       Cartes sans data-prix-m2 : rejetées en fin de liste. */
    var grille = racine.querySelector('.coll-grid');
    var triM2Actif = '';

    function trierParM2(sens) {
      if (!grille) return;
      var lis = Array.prototype.slice.call(racine.querySelectorAll('.coll-grid > li'));
      lis.sort(function (a, b) {
        var aa = a.querySelector('article');
        var bb = b.querySelector('article');
        var pa = aa && aa.getAttribute('data-prix-m2') ? parseInt(aa.getAttribute('data-prix-m2'), 10) : Infinity;
        var pb = bb && bb.getAttribute('data-prix-m2') ? parseInt(bb.getAttribute('data-prix-m2'), 10) : Infinity;
        return sens === 'desc' ? pb - pa : pa - pb;
      });
      lis.forEach(function (li) { grille.appendChild(li); });
    }

    if (tri) {
      tri.addEventListener('change', function () {
        var opt = tri.options && tri.options[tri.selectedIndex];
        var sens = opt && opt.getAttribute && opt.getAttribute('data-m2');
        if (sens && grille) {
          triM2Actif = sens;
          trierParM2(sens);
          return; /* pas de rechargement : tri instantané */
        }
        var hote = tri.form || form;
        if (hote) hote.submit();
      });
    }

    if (drawer) {
      var fermer = drawer.querySelector('[data-coll-drawer-close]');
      if (fermer) {
        fermer.addEventListener('click', function () {
          drawer.removeAttribute('open');
          var resume = drawer.querySelector('summary');
          if (resume) resume.focus();
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.hasAttribute('open')) {
          drawer.removeAttribute('open');
          var resume = drawer.querySelector('summary');
          if (resume) resume.focus();
        }
      });

      document.addEventListener('click', function (e) {
        if (!drawer.hasAttribute('open')) return;
        if (e.target === drawer || !drawer.contains(e.target)) {
          drawer.removeAttribute('open');
        }
      });
    }

    initFiltresRapides(racine, {
      resort: function () {
        if (triM2Actif) trierParM2(triM2Actif);
      }
    });
  }

  function initTout(scope) {
    (scope || document).querySelectorAll('[data-coll]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTout(); });
  } else {
    initTout();
  }

  /* Rechargement de section dans l'éditeur de thème. */
  document.addEventListener('shopify:section:load', function (e) {
    initTout(e.target);
  });
})();
